<template>
    <div>
    <h3 class="content-block openware-form-title">{{ title }}</h3>

        <DxPopup
            :drag-enabled="false"
            :hide-on-outside-click="true"
            :show-close-button="true"
            :show-title="true"

            :columns="columns"
            :allow-column-reordering="true"
            :allow-column-resizing="true"
            :column-auto-width="true"
            :show-borders="true"
            :show-column-lines="true"
            :show-row-lines="true"
            :row-alternation-enabled="true"
            :focused-row-enabled="true"
            title="Διαχείριση Ραντεβού"
            :width="'90%'" 
            :height="'90%'"

            v-model:visible="isPopupVisible"
            titleTemplate="title"
            deferRendering="true"
            :animation="{
                        show: {
                            type: 'pop',
                            duration: 800,
                            from: {
                                scale: 0.90
                            }
                        }, 
                        }"
        >
            <DxScrollView height="100%" width="100%" ref="FormScrollViewRef">
                <AppointmentForm
                    ref="appointmentForm"
                    :appointment_id="selectedAppointmentID" 
                    @closePopupEvent="onClosePopupEmit">
                </AppointmentForm>
            </DxScrollView>

        </DxPopup>
        <!-- <pre>{{ visibleRange }}</pre> -->

        <DxToolbar>
                <DxItem locate-in-menu="auto" location="before">
                    <div class ="ow-list-filters" style="display: flex;">
                        <div class="ow-list-filter">
                            <label class="filter-label" for="lookupConfirmed">Επιβεβαιωμένο:</label>
                            <DxLookupEx
                                ref="lookupConfirmedRef"
                                id="lookupConfirmed"
                                :searchEnabled="false"
                                :data-source="dataSourceConfirmed"
                                :disabled="userIsTechnician"
                                :value="1"
                                :width="90"
                                :input-attr="{ 'aria-label': 'Grouped lookup' }"
                                value-expr="value"
                                display-expr="title"
                                @initialized="onInitializedConfirmed"
                                @value-changed="onValueChangedConfirmed"
                            >
                            <DxDropDownOptions
                                :hide-on-outside-click="true"
                                :show-title="false"
                            />
                            </DxLookupEx>
                        </div>
                    </div>
                </DxItem>

                <DxItem location="after">
                    <DxDateBox 
                        placeholder="Ημερομηνία"
                        :show-clear-button="true"
                        :use-mask-behavior="true"
                    />
                </DxItem>
                <DxItem location="after" 
                            widget="dxButton" 
                            :options="{
                                icon: 'add',
                                text: '',
                                hint: 'Προσθήκη',
                                onClick: () => {
                                    onCustomInitNewRow()
                                }
                            }"

                    />
                <DxItem name="exportButton" 
                    :options="{
                            hint: 'Εξαγωγή δεδομένων'
                        }"
                />
        </DxToolbar>

        <DxScheduler 
                id="scheduler"
                ref="schedulerRef"
                :data-source="CustomStoreMain"
                :adaptivity-enabled="true"
                text-expr="client_name"
                all-day-expr="dayLong"
                recurrence-rule-expr="recurrence"
                
                :height="'100%'"
                v-model:current-date="currentDate"
                v-model:current-view="currentView"

                appointment-template="myAppointmentTemplate"

                :cell-duration="30"
                :start-day-hour="6"
                :end-day-hour="22"
                :first-day-of-week="1"
                
                :on-appointment-click="onAppointmentClick"
                :on-appointment-dbl-click="onAppointmentClick"

                @appointment-rendered="onAppointmentRendered"

                @option-changed="onOptionChanged"
                @cell-click="onCellClick"
                @initialized="onSchedulerInitialized"
                @content-ready="onContentReady"
                @appointment-form-opening="onAppointmentFormOpening">

                <DxEditing
                    :allow-updating="true"
                    :allow-dragging="true"
                    :allow-resizing="true"
                    :allow-adding="true"
                    :allow-deleting="true"/>

                <DxResource
                    field-expr="technician_id"
                    value-expr="id"
                    color-expr="color"
                    display-expr="name"
                    label="Υπάλληλος"
                    :data-source="LookupCustomDS_ow_view_technicians" />

                <DxView type="day" name="Ημέρα" :groups="groups"/>
                <DxView type="week" name="Εβδομάδα" :max-appointments-per-cell="unlimited"/>
                <DxView type="month" name="Μήνας" :max-appointments-per-cell="unlimited"/>
                <DxView type="agenda" name="Ημερολόγιο" />
                <!--
                <DxView type="timelineDay" />
                <DxView type="timelineWeek" />
                <DxView type="timelineMonth" />
                -->

                <template #time-cell="{ data }">
                    <i style="color: green">{{data.text}}</i>
                </template>

                <template #myAppointmentTemplate="{ data }">
                    <div class="custom-appointment">
                        <!-- Title (ΦΟΥΡΝΟΣ ΜΠΟΡΙΤΣΗ ΡΕΦΙΑ) -->
                        <div class="appointment-title">
                            {{ data.appointmentData.client_name}}
                        </div>

                        <!-- Time (6:00 π.μ. - 7:00 π.μ.) -->
                        <div class="appointment-time">
                            {{ formatTime(data.appointmentData.startDate) }} - 
                            {{ formatTime(data.appointmentData.endDate) }}
                        </div>

                        <!-- THE ADDITION: Technician Name at the bottom -->
                        <div class="appointment-tech" v-if="data.appointmentData.technician_id !== 0">
                            👤 {{ data.appointmentData.technician }}
                        </div>
                    </div>
                </template>

        </DxScheduler>

    </div>

    </template>

    <script setup>

    import 'whatwg-fetch'
    import CustomStore from 'devextreme/data/custom_store'

    //import { DxCheckBox } from 'devextreme-vue/check-box'
    import { DxLookup as DxLookupEx, DxDropDownOptions } from 'devextreme-vue/lookup'

    import { DxScheduler, DxView, DxResource, DxEditing } from 'devextreme-vue/scheduler';

    import DxPopup from 'devextreme-vue/popup'
    import DxScrollView from 'devextreme-vue/scroll-view'
    import AppointmentForm from './ow-appointments-form.vue'

    import DataSource from 'devextreme/data/data_source'

    import OParameters from '../es-globals';

    import { ref, watch, /*reactive, computed,*/ onMounted } from 'vue'

    //import { exportDataGrid } from 'devextreme/pdf_exporter'

    const schedulerRef = ref(null)
    const currentDate  = ref(new Date())
    const currentView  = ref("day")
    const visibleRange = ref({ start: null, end: null, days: [] })
    const groups = ['technician_id'];

    
    const FormScrollViewRef = ref(null)
    const appointmentForm = ref(null)

    const selectedAppointmentID = ref(null)
    const isPopupVisible = ref(false)

    const confirmedInd = ref(1)

    const lookupConfirmedRef = ref(null)

    const title = 'Ημερολόγιο'

    var userIsTechnician = false

    /*  
    const formatCurrency = { 
                        type: 'currency',
                        currency: 'EUR', 
                        useGrouping: true, 
                        precision: 2 
                    }
    */

    const URL_SERVICE = OParameters.Host.URI + 'ow_appointments'
    const URL_SERVICE_ow_view_rep_daily_programme = OParameters.Host.URI + 'ow_view_rep_daily_programme'
    const URL_SERVICE_LOOKUP_ow_view_technicians = OParameters.Host.URI + 'ow_view_technicianswithunassigned';

    const confirmedIndFilter = [{ id: 1, title: 'Ναι', value: 1, }, { id: 2, title: 'Όχι', value: 0, }, { id: 3, title: 'Ναι & Όχι', value: -1, }]

    const dataSourceConfirmed = new DataSource({
            key: 'id',
            store: confirmedIndFilter,
    })

    const LookupCustomDS_ow_view_technicians = new CustomStore({
        key: 'id',
        //loadMode: 'raw',
        load: () => sendRequest(URL_SERVICE_LOOKUP_ow_view_technicians + '?order=id'),
        byKey: (key) => sendRequestByKey(URL_SERVICE_LOOKUP_ow_view_technicians + "/" + encodeURIComponent(key)),
    })
    
    const CustomStoreMain = new CustomStore({
        key: 'id',
        // loadMode: 'raw',
        load: () => {
            const url = `${URL_SERVICE_ow_view_rep_daily_programme}?filter=startDt,ge,${visibleRange.value.start}&filter=endDt,le,${visibleRange.value.end}`
                        + (confirmedInd.value > -1 ? `&filter=confirmed_ind,eq,${confirmedInd.value}` : '');
            return sendRequest(url)

        },
        //load: () => sendRequest(URL_SERVICE_ow_view_rep_daily_programme + '?filter=app_date_formatted,eq,' + selectedYear + '-' + selectedMonth.toString().padStart(2, '0') + '-' + selectedDay.toString().padStart(2, '0')),
        insert: async (values) => {
            console.log("insert values", values)
            return sendRequest(URL_SERVICE, 'POST', values)
        },

        //update: (key, values) => sendRequest(URL_SERVICE + '/' + encodeURIComponent(key), 'PUT', values),
        
        // Update: values is partial. Merge with current (byKey) then map.
        update: async (key, values) => {
          console.log("update values", values)
          const current = await sendRequest(`${URL_SERVICE}/${encodeURIComponent(key)}`) // table item
          const payload = mapToAppointmentPayload(values, current)
          return sendRequest(`${URL_SERVICE}/${encodeURIComponent(key)}`, 'PUT', payload)
        },
        remove: (key) => sendRequest(URL_SERVICE + '/' + encodeURIComponent(key), 'DELETE'),
        byKey: (key) => sendRequest(URL_SERVICE + "/" + encodeURIComponent(key)),
    })

    // 
    //  Based on: https://js.devexpress.com/Demos/WidgetsGallery/Demo/DataGrid/CRUDOperations/Vue/GreenMist/
    //
    const sendRequest = (url, method = 'GET', values = {}) => {
        // console.log('LOG: ' + url + ' METHOD: ' + method + ' VALUES: ' + JSON.stringify(values, null, 4));
        if (method === 'GET') {
            return fetch(url, {
                method,
                credentials: 'include',
            })
            .then(response => {
                return response.json().then(json => {
                    if (response.ok) return json.records;
                    throw json.Message;
                });
            });
        }
        return fetch(url, {
            method,
            body: JSON.stringify(values),
            headers: {
                'Content-Type': 'application/json', //'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
            },
            credentials: 'include',
        }).then((result) => {
            if (result.ok) {
                return result.text().then((text) => text && JSON.parse(text));
            }
            return result.json().then((json) => {
                throw json.Message;
            });
        });
    }

    const sendRequestByKey = (url, method = 'GET') => {
        return fetch(url, {
                        method,
                        headers: {
                            'Accept': 'application/json',
                        },
                        credentials: 'include',
                    })
                    .then(response => response.json())
    }

    const updateVisibleRange = () => {
        //console.log("updateVisibleRange")
        if (!schedulerRef.value) schedulerRef.value = { instance: e.component }
        const inst = schedulerRef.value?.instance
        if (!inst) return
        const start = inst.getStartViewDate()
        const end   = inst.getEndViewDate()

        // optional: list all days in the visible range
        const days = []
        const d = new Date(start)
        while (d <= end) {
            days.push(d.toISOString().split("T")[0])
            d.setDate(d.getDate() + 1)
        }
        visibleRange.value = { start: start.toISOString().split("T")[0], end: end.toISOString().split("T")[0], days }

        //console.log("visibleRange.value", visibleRange.value)
        schedulerRef.value.instance.getDataSource().reload()
    }

    function toSqlDateTime(dt) {
        // MySQL DATETIME: 'YYYY-MM-DD HH:MM:SS' (local)
        const pad = n => String(n).padStart(2, '0')
        const d = new Date(dt)
        const y = d.getFullYear()
        const m = pad(d.getMonth() + 1)
        const day = pad(d.getDate())
        const hh = pad(d.getHours())
        const mm = pad(d.getMinutes())
        const ss = pad(d.getSeconds())
        return `${y}-${m}-${day} ${hh}:${mm}:${ss}`
    }
    

    // Map from Scheduler/View fields to table fields expected by /ow_appointments
    function mapToAppointmentPayload(values, oldItem) {
        // values = changed fields from Scheduler (may be partial)
        // oldItem = previous full item (useful to fill required fields if missing)

        const src = { ...(oldItem || {}), ...(values || {}) }

        console.log("src.startDt", src.startDate)
        console.log("toSqlDateTime(src.startDt)", toSqlDateTime(src.startDate))

        return {
            // id is path param; exclude here
            //company_id: src.company_id ?? oldItem?.company_id,   // if needed server-side
            //client_id:  src.client_id ?? oldItem?.client_id,     // Scheduler shows client_name; you must keep client_id in the item
            
            technician: src.technician_id ?? oldItem?.technician, // your table uses 'technician' (int), view uses 'technician_id'
            confirmed_ind: src.confirmed_ind ?? oldItem?.confirmed_ind,
            appointment_date: src.startDate ? toSqlDateTime(src.startDate) : oldItem?.appointment_date ? toSqlDateTime(oldItem.appointment_date) : null,

            // Optional: map other editable fields if you expose them in the form:
            //appointment_address: src.appointment_address ?? oldItem?.appointment_address,
            //work_type_id:        src.work_type_id ?? oldItem?.work_type_id,
            
            //admin_comment:       src.admin_comment ?? oldItem?.admin_comment,
            //technician_comment:  src.technician_comment ?? oldItem?.technician_comment,
            // ... add any others you actually let the user edit
        }
    }

    const onSchedulerInitialized = () => {
        console.log("onSchedulerInitialized")
    }

    const onContentReady = () => {
        console.log("onContentReady")
        updateVisibleRange()
    }

    const onClosePopupEmit = () => {
        console.log("onClosePopupEmit")
        FormScrollViewRef.value.instance.scrollTo(0)
        isPopupVisible.value = false
        schedulerRef.value.instance.getDataSource().reload()
    }

    const onCustomInitNewRow = (e) => {
        console.log("onCustomInitNewRow", e)
        selectedAppointmentID.value = null;
        appointmentForm.value.loadFormData(selectedAppointmentID.value)
        isPopupVisible.value = true;
    }

    const onAppointmentFormOpening = (e) => {
        //console.log("onAppointmentFormOpening", e)
        e.cancel = true
        selectedAppointmentID.value = e.appointmentData.id

        appointmentForm.value.loadFormData(selectedAppointmentID.value, e.appointmentData)
        isPopupVisible.value = true

    }

    const isPast = (d) => d && new Date(d).getTime() < Date.now()

/*
    const dataCellTemplate = (cellData) => {
        const el = document.createElement('div')
        const cellStart = cellData?.startDate || cellData?.date
        if (isPast(cellStart)) {
            el.className = 'dx-past-cell' // visual only; keep events alive
        }
        return el
    }
*/
    function onCellClick(e) {
        if (isPast(e.cellData?.startDate)) e.cancel = true // block creating in past
    }

    // 👇 NEW: hook into rendering of appointments
    function onAppointmentRendered(e) {
        const { appointmentData, appointmentElement } = e
        if (appointmentData && isPast(appointmentData.startDate)) {
            const el = e.appointmentElement?.get?.(0) || e.appointmentElement
            if (el) {
                el.classList.add('dx-past-appointment') // apply your class
            }
        }
        if (appointmentData.confirmed_ind == 1) {
            // A soft "Mint" green
            appointmentElement.style.backgroundColor = "#d4edda"; 
            appointmentElement.style.color = "#155724"; // Dark green text for contrast
            appointmentElement.style.borderLeft = "5px solid #28a745"; // Stronger side accent
        } else {
            // A soft "Cream" yellow
            appointmentElement.style.backgroundColor = "#fff3cd"; 
            appointmentElement.style.color = "#856404"; // Dark brown/yellow text
            appointmentElement.style.borderLeft = "5px solid #ffc107";
        }

        // 2. Add the Mouseover Hint (Browser Title)
        // Use \n for line breaks in the hint box
        const techName = appointmentData.technician;
        
        appointmentElement.setAttribute('title', 
            `Πελάτης: ${appointmentData.client_name}\n` +
            `Ώρα: ${appointmentData.startDate} - ${appointmentData.endDate || '-'}\n` +
            `Τεχνικός: ${techName}`
        );
    }

    function onAppointmentClick(e) {
        if (isPast(e.appointmentData?.startDate)) e.cancel = true // block tooltip/edit
        //console.log("Appointment clicked:", e);
    }

    const onOptionChanged = (e) => {
        if (e.fullName === "currentDate") {
            console.log("Date Navigator changed e:", e);
            //currentDate.value = e.value;
        }
    }

    const onValueChangedConfirmed = (e) => {
        confirmedInd.value = e.value
        schedulerRef.value.instance.getDataSource().reload()
    }

    const formatTime = (date) => {
        return new Intl.DateTimeFormat('el-GR', {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        }).format(new Date(date));
    }

    // Lifecycle hooks
    onMounted(() => {
        console.log("onMounted");
        updateVisibleRange
    })

    watch([currentDate, currentView], updateVisibleRange)

</script>
<style lang="scss">
    .dx-group-cell.dx-last-data-cell {
        font-weight: bold;
    }

    /* Style for disabled past cells */
    .dx-past-cell {
        background-color: #f5f5f5;
        opacity: 0.6;
    }

    .appointment-title {
        font-weight: normal;
        font-size: 12px;
    }

    .appointment-time {
        font-size: 11px;
        color: #555;
    }

    .appointment-tech {
        font-size: 11px;
        color: #007bff;
        margin-top: 4px;
    }

    /* Past appointments */
    .dx-past-appointment {
        opacity: 0.6;
        filter: grayscale(0.3);
    }

</style>
